var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeHandCheckIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16.3px",
    height: "17px",
    viewBox: "0 0 16.3 17",
    style: {
      enableBackground: "new 0 0 16.3 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E64B38;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.1,0.1c-0.2-0.2-0.6-0.2-0.8,0c-3.6,3.9-6.8,8.3-9.5,13c-1.4-1.6-3-3-4.7-4.2c-0.3-0.2-0.7-0.2-1,0.1 c-0.3,0.3-0.3,0.8,0,1.1C2.1,12,3.7,14.1,5,16.4c0.1,0.2,0.3,0.4,0.6,0.5c0.7,0.3,1.4,0,1.7-0.7l0,0l0,0c2.3-5.4,5.2-10.6,8.8-15.3 C16.4,0.7,16.4,0.3,16.1,0.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeHandCheckIcon);
export default __webpack_public_path__ + "static/media/free-hand-check-icon.b7f464959a6bdab7e61edf94062c88cf.svg";
export { ForwardRef as ReactComponent };